import { render, staticRenderFns } from "./yesnoType.vue?vue&type=template&id=2d96cc66"
import script from "./yesnoType.vue?vue&type=script&lang=js"
export * from "./yesnoType.vue?vue&type=script&lang=js"
import style0 from "./yesnoType.vue?vue&type=style&index=0&id=2d96cc66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports